import request from '@/utils/request';

/**
 * @description 用户登录
 * @param username
 * @param password
 * @returns {*}
 */
function userLogin({ username, password } = {}) {
  return request({
    url: 'account/login',
    method: 'post',
    data: {
      account: username,
      password
    },
    isToken: false
  });
}

export default {
  userLogin
};
